import { render, staticRenderFns } from "./DeviceDetailInactive.vue?vue&type=template&id=2e68947f&scoped=true&"
import script from "./DeviceDetailInactive.vue?vue&type=script&lang=js&"
export * from "./DeviceDetailInactive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e68947f",
  null
  
)

export default component.exports